import {
  Table,
  TableBody,
  TableHead,
  TableRow,
  TableCell,
  LinearProgress,
  TableContainer,
  TableHeader,
  NO_DATA_PLACEHOLDER_DASH,
} from '@occc-app/design-system';
import { TransactionPaymentEventFragment } from '@occc/graphql';
import { readableDateWithShortTimezone } from '@occc-app/lib/format';

import { detailsPage as copy } from './transaction-details.copies';
import { getTransactionEventTypeLabel } from './transaction-details.utils';

type TransactionPaymentEventsProps = {
  paymentEvents: (TransactionPaymentEventFragment | null)[];
  loading?: boolean;
};

export const TransactionPaymentEvents = ({
  paymentEvents,
  loading,
}: TransactionPaymentEventsProps) => (
  <TableContainer
    sx={(theme) => ({
      marginBottom: theme.spacing(1),
    })}
  >
    <TableHeader title={copy.paymentEventsSection.title} />
    {loading && <LinearProgress />}
    <Table>
      <TableHead>
        <TableRow>
          <TableCell>Completed At</TableCell>
          <TableCell>Processor Response Code</TableCell>
          <TableCell>POS Response Code</TableCell>
          <TableCell>Description</TableCell>
          <TableCell>Transaction Event Type</TableCell>
        </TableRow>
      </TableHead>
      <TableBody>
        {paymentEvents.map((item, index) => (
          <TableRow key={index}>
            <TableCell>
              {item?.completedAt
                ? readableDateWithShortTimezone(item?.completedAt)
                : NO_DATA_PLACEHOLDER_DASH}
            </TableCell>
            <TableCell>{item?.processorResponseCode || NO_DATA_PLACEHOLDER_DASH}</TableCell>
            <TableCell>{item?.posResponseCode || NO_DATA_PLACEHOLDER_DASH}</TableCell>
            <TableCell>{item?.reasonDescription || NO_DATA_PLACEHOLDER_DASH}</TableCell>
            <TableCell>
              {item?.transactionEventType
                ? getTransactionEventTypeLabel(item.transactionEventType)
                : NO_DATA_PLACEHOLDER_DASH}
            </TableCell>
          </TableRow>
        ))}
      </TableBody>
    </Table>
  </TableContainer>
);
